import { render, staticRenderFns } from "./HotelsTabs.vue?vue&type=template&id=1c33ac80&"
import script from "./HotelsTabs.vue?vue&type=script&lang=js&"
export * from "./HotelsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports